<template>
  <div class="md:hidden fixed bottom-0 left-0 right-0 bg-gray-800 text-white shadow-lg z-50">
    <div class="flex justify-around py-2">
      <router-link 
        to="/" 
        class="flex flex-col items-center px-3 py-2 rounded-lg text-gray-300 hover:text-white"
        active-class="text-white bg-blue-500"
      >
        <i class="fas fa-home mb-1"></i>
        <span class="text-xs">主页</span>
      </router-link>
      
      <router-link 
        to="/matches" 
        class="flex flex-col items-center px-3 py-2 rounded-lg text-gray-300 hover:text-white"
        active-class="text-white bg-blue-500"
      >
        <i class="fas fa-calendar-alt mb-1"></i>
        <span class="text-xs">赛程</span>
      </router-link>
      
      <router-link 
        to="/league-table" 
        class="flex flex-col items-center px-3 py-2 rounded-lg text-gray-300 hover:text-white"
        active-class="text-white bg-blue-500"
      >
        <i class="fas fa-table mb-1"></i>
        <span class="text-xs">积分榜</span>
      </router-link>
      
      <router-link 
        to="/player-analysis" 
        class="flex flex-col items-center px-3 py-2 rounded-lg text-gray-300 hover:text-white"
        active-class="text-white bg-blue-500"
      >
        <i class="fas fa-user mb-1"></i>
        <span class="text-xs">球员</span>
      </router-link>
    </div>
  </div>
</template>

<script setup>
// 移动端导航组件
</script>